import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import { AnimatePresence } from "framer-motion";

import Loader from "./components/Loader";
import GetInTouch from "./components/GetInTouch";
import Main from "./components/Main";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Login from "./components/Login";
import AdminDashboard from "./components/AdminDashboard";

function PortfolioHome() {
  const [isLoading, setIsLoading] = useState(() => {
    return !sessionStorage.getItem("portfolio_has_visited");
  });

  const handleLoaderComplete = () => {
    sessionStorage.setItem("portfolio_has_visited", "true");
    setIsLoading(false);
  };

  const [refExperience, inViewExperience] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const [refSkills, inViewSkills] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const experienceProps = useSpring({
    opacity: inViewExperience ? 1 : 0,
    transform: inViewExperience ? "translateY(0px)" : "translateY(40px)",
    config: { tension: 120, friction: 20 },
  });

  const skillsProps = useSpring({
    opacity: inViewSkills ? 1 : 0,
    transform: inViewSkills ? "translateY(0px)" : "translateY(40px)",
    config: { tension: 120, friction: 20 },
  });

  return (
    <>
      <AnimatePresence mode="wait">
        {isLoading && <Loader onComplete={handleLoaderComplete} />}
      </AnimatePresence>

      <div className="bg-[#0F172A] min-h-screen text-slate-100 selection:bg-[#00B4DB]/30 selection:text-[#00B4DB] overflow-x-hidden font-sans">
        <Navbar />

        {/* Intro Header */}
        <Main />

        {/* Work / Projects */}
        <Work />

        {/* Experience */}
        <animated.div ref={refExperience} style={experienceProps}>
          <Experience />
        </animated.div>

        {/* Skills */}
        <animated.div ref={refSkills} style={skillsProps}>
          <Skills />
        </animated.div>

        {/* Contact */}
        <GetInTouch />

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<PortfolioHome />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminDashboard />} />
    </Routes>
  );
}

export default App;

